// Estilos — tema escuro alinhado ao dashboard (roxo/cyan)
export const styles = {
  container: {
    padding: "24px 20px",
    maxWidth: "900px",
    margin: "0 auto",
  },
  title: {
    marginBottom: "24px",
    textAlign: "center",
    fontSize: "2rem",
    fontWeight: "700",
    background: "linear-gradient(135deg, #B026FF 0%, #00D4FF 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    textTransform: "uppercase",
    letterSpacing: "2px",
  },
  selectContainer: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "600",
    fontSize: "12px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "#B0BEC5",
  },
  tabContainer: {
    marginTop: "24px",
    border: "1px solid rgba(0, 212, 255, 0.3)",
    borderRadius: "12px",
    overflow: "hidden",
    background: "linear-gradient(135deg, rgba(10, 14, 39, 0.95) 0%, rgba(176, 38, 255, 0.15) 100%)",
  },
  tabHeader: {
    display: "flex",
    flexWrap: "wrap",
    borderBottom: "1px solid rgba(0, 212, 255, 0.2)",
  },
  tabButton: {
    flex: "1 1 auto",
    minWidth: "120px",
    padding: "12px 16px",
    borderWidth: 0,
    borderStyle: "solid",
    borderColor: "transparent",
    borderBottomWidth: 2,
    borderBottomColor: "transparent",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
    transition: "all 0.2s ease",
  },
  tabButtonActive: {
    background: "linear-gradient(135deg, #B026FF 0%, #0066FF 100%)",
    color: "#fff",
    borderBottomColor: "rgba(0, 212, 255, 0.6)",
  },
  tabButtonInactive: {
    background: "rgba(51, 65, 85, 0.4)",
    color: "#94a3b8",
  },
  tabContent: {
    padding: "24px",
  },
  buttonPrimary: {
    padding: "12px 24px",
    background: "linear-gradient(135deg, #B026FF 0%, #0066FF 100%)",
    color: "#fff",
    border: "1px solid rgba(0, 212, 255, 0.5)",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "700",
    cursor: "pointer",
    marginBottom: "10px",
  },
  buttonDanger: {
    padding: "10px 20px",
    background: "rgba(239, 68, 68, 0.25)",
    color: "#fca5a5",
    border: "1px solid rgba(239, 68, 68, 0.5)",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    marginBottom: "10px",
    opacity: 0.9,
  },
  message: {
    padding: "12px 16px",
    borderRadius: "8px",
    marginBottom: "20px",
  },
  messageSuccess: {
    background: "rgba(34, 197, 94, 0.2)",
    color: "#86efac",
    border: "1px solid rgba(34, 197, 94, 0.4)",
  },
  messageError: {
    background: "rgba(239, 68, 68, 0.2)",
    color: "#fca5a5",
    border: "1px solid rgba(239, 68, 68, 0.4)",
  },
  loadingText: { color: "#94a3b8", marginBottom: "16px" },
  emptyText: { color: "#94a3b8", marginBottom: "16px" },
  errorText: { color: "#f87171", marginBottom: "16px" },
  leadCount: {
    marginBottom: "20px",
    fontSize: "15px",
    color: "#e2e8f0",
  },
  leadList: {
    maxHeight: "500px",
    overflowY: "auto",
  },
  leadItem: {
    marginBottom: "12px",
    border: "1px solid rgba(0, 212, 255, 0.2)",
    borderRadius: "12px",
    overflow: "hidden",
    background: "rgba(30, 41, 59, 0.5)",
  },
  leadHeader: {
    padding: "14px 18px",
    background: "rgba(51, 65, 85, 0.4)",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  leadName: {
    fontWeight: "600",
    flex: "1",
    color: "#e2e8f0",
  },
  leadDate: {
    color: "#94a3b8",
    marginRight: "12px",
    fontSize: "13px",
  },
  expandIcon: {
    fontSize: "12px",
    color: "#00D4FF",
  },
  leadDetails: {
    padding: "16px 18px",
    background: "rgba(51, 65, 85, 0.35)",
    borderTop: "1px solid rgba(0, 212, 255, 0.15)",
  },
  detailRow: {
    marginBottom: "10px",
    display: "flex",
    flexWrap: "wrap",
  },
  detailLabel: {
    fontWeight: "600",
    width: "150px",
    flexShrink: 0,
    color: "#94a3b8",
    fontSize: "13px",
  },
  detailValue: {
    flex: "1",
    color: "#e2e8f0",
    fontSize: "14px",
  },
  interestBadge: {
    padding: "4px 10px",
    borderRadius: "8px",
    color: "#fff",
    fontSize: "13px",
    display: "inline-block",
  },
  urgencyBadge: {
    padding: "4px 10px",
    borderRadius: "8px",
    color: "#fff",
    fontSize: "13px",
    display: "inline-block",
  },
  badgeHigh: { background: "rgba(34, 197, 94, 0.5)", border: "1px solid rgba(34, 197, 94, 0.6)" },
  badgeMedium: { background: "rgba(234, 179, 8, 0.4)", border: "1px solid rgba(234, 179, 8, 0.6)" },
  badgeLow: { background: "rgba(239, 68, 68, 0.4)", border: "1px solid rgba(239, 68, 68, 0.5)" },
  statusSent: { color: "#86efac" },
  statusPending: { color: "#fca5a5" },
  sectionTitle: {
    color: "#e2e8f0",
    fontSize: "1.25rem",
    fontWeight: "700",
    marginBottom: "16px",
  },
  exportContainer: {
    maxWidth: "600px",
    margin: "0 auto",
  },
  formGroup: {
    marginBottom: "20px",
  },
  input: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: "8px",
    border: "1px solid rgba(0, 212, 255, 0.3)",
    fontSize: "14px",
    marginTop: "6px",
    background: "rgba(10, 14, 39, 0.8)",
    color: "#fff",
  },
  button: {
    background: "linear-gradient(135deg, #B026FF 0%, #0066FF 100%)",
    color: "#fff",
    border: "1px solid rgba(0, 212, 255, 0.5)",
    padding: "12px 20px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
    marginRight: "10px",
  },
  buttonSecondary: {
    background: "rgba(80, 112, 255, 0.25)",
    color: "#e2e8f0",
    border: "1px solid rgba(0, 212, 255, 0.4)",
    padding: "12px 20px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
  },
  buttonGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginTop: "20px",
  },
  webhookContainer: {
    maxWidth: "600px",
    margin: "0 auto",
  },
  webhookDescription: {
    marginBottom: "20px",
    color: "#94a3b8",
    fontSize: "14px",
    lineHeight: 1.5,
  },
  helperText: {
    fontSize: "12px",
    color: "#94a3b8",
    marginTop: "6px",
  },
};
